// Session token store + authenticated fetch wrapper.
//
// The Make-Admin dashboard is served from a different site than the Rails API
// (e.g. groov-production-make-admin.onrender.com vs the backend host), so the
// session cookie is third-party. iOS/desktop Safari's ITP blocks third-party
// cookies even with SameSite=None;Secure, which silently logs the admin out.
// To stay robust everywhere we also send the session token as a bearer header —
// first-party localStorage on the dashboard origin, immune to cookie policy.
// The backend checks the bearer token before the cookie (see
// Authentication#find_session_by_cookie), so this works alongside cookies
// wherever they're still allowed.
//
// Key is "token" to match the existing reads in the app.
const TOKEN_KEY = "token";

export const getToken = () => {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null; // localStorage can throw in private mode / when disabled
  }
};

export const setToken = (token) => {
  try {
    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      localStorage.removeItem(TOKEN_KEY);
    }
  } catch {
    // Best-effort: if storage is unavailable the cookie path still applies.
  }
};

export const clearToken = () => setToken(null);

// Drop-in replacement for fetch() against the backend: attaches
// `Authorization: Bearer <token>` when present and keeps cookies for browsers
// that still allow them.
export const authFetch = (url, options = {}) => {
  const token = getToken();
  return fetch(url, {
    ...options,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
      ...(options.headers || {}),
    },
    credentials: "include",
  });
};
